import React from 'react';
import {
    Typography,
    Divider,
    Button,
    Card,
} from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import ShareIcon from '@mui/icons-material/Share';
import CardMedia from '@mui/material/CardMedia';
import A8AXIS from '../../components/A8/A8AXIS';
import CATEGORY_IMAGE from '../../../static/biz-professional/shibuyasky-4768679_1280.jpeg';
import { useNavigate } from 'react-router-dom';
import GL_IMAGE from '../../../static/biz-professional/GalleryLambda-Slide-Issue.png';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';

interface ArticlePageProps {
    path: string;
}


const Article: React.FC<ArticlePageProps> = ({ path }) => {
    const handleCopyClick = () => {
        navigator.clipboard.writeText(path)
            .then(() => {
                console.log('Link copied to clipboard!');
            })
            .catch((err) => {
                console.error('Unable to copy link to clipboard', err);
            });
    };

    const navigate = useNavigate()
    const handleImageClick = (path: string) => {
        navigate(path);
        window.scrollTo(0, 0);
    };
    return (
        <div>
            <Box sx={{ mt: 7, mb: 12, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                <Card elevation={0} sx={{ maxWidth: 1000 }} style={{ margin: '0px', padding: '5px' }}>
                    <CardContent>
                        <Typography variant="h1" id="introduction" style={{ fontSize: '30px' }}>
                            第1回: イシューを洗い出そう。そして、構造化しよう。
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="body2" color="text.primary">
                            Published on 2024 Jan 12th <br />
                            10 min read  <br />
                            by Michelle
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            プレゼンの背景となる課題は何か。言い換えると、プレゼンのリスナーの興味は何か。その分析なしに良いプレゼンは出来上がりません。
                            本記事では以下のトピックを具体例を交えてご説明したいと思います。1. そもそもプレゼンにおけるイシュー分析とは何か。2. イシューの構造化とは何か。
                            プレゼンの背景となる課題の分析というと、プレゼンの完成度やリスナーの満足度と必ずしも紐づかないのではないでしょうか。
                            戦略コンサルに入ると徹底的に叩き込まれるイシュー分析の重要性。今日は、そんな話をお伝えできればと思います。
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Button variant="text" size="small" endIcon={<ShareIcon />} style={{ color: 'black' }} onClick={handleCopyClick}>
                            Copy URL of this ariticle
                        </Button>
                    </CardContent>
                    <CardMedia
                        component="img"
                        height="500"
                        sx={{

                            objectFit: 'cover',
                            filter: 'grayscale(90%)',
                        }}
                        image={CATEGORY_IMAGE}
                        alt="image of the category"
                    />
                    <CardContent>
                        <Typography variant="body2" color="text.secondary">
                            イシューを洗い出そう。そして、構造化しよう。
                        </Typography>
                    </CardContent>
                    <Divider style={{ margin: '20px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px', fontWeight: 'lighter' }}>Table of Contents</Typography>
                    </CardContent>
                    <ol>
                        <li><a href="#1">そもそもプレゼンにおけるイシュー分析とは何か。</a></li>
                        <li><a href="#2">イシューの構造化とは何か。</a></li>
                        <li><a href="#3">最後に一言。</a></li>
                    </ol>
                    <Divider id="1" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>そもそもプレゼンにおけるイシュー分析とは何か。</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            課題の分析、イシューの分析というと、市場調査や事業戦略を作る際と比較すると、プレゼンに必ず必要なものという意識は少ないのではないでしょうか。
                            ケーススタディを通じて、説明していきたいと思います。
                            <br />
                            <br />

                            <Card elevation={3}>
                                <CardContent>
                                    <Typography variant="h4" style={{ fontSize: '22px' }}>ケーススタディ - 上司からの急なプレゼンの依頼 </Typography>
                                    <Typography paragraph style={{ fontSize: '20px' }}>
                                        <br />あなたは50人の部下を抱える、とあるプロダクトチームのトップです。同じディパートメントには同規模のプロダクトチームが複数ありますが、特に横のチームとの連携はありません。
                                        あなたは上司であるディパートメントヘッドからの依頼で、「来週、あなたのチームは最近いろいろ上手くいっているから簡単にナレッジシェアをしてほしい」と言われました。30分のプレゼンだそうです。依頼は唐突でしたし、
                                        とはいえ、特にアジェンダは言われませんでした。もしプレゼンの反響が良ければ、継続的に会を運営してもらうかも、と言っています。
                                        さて、あなたは何を会議をどう設計し、何をプレゼンしますか。
                                    </Typography>
                                </CardContent>
                            </Card>
                            <br />
                            <br />
                            みなさん、どうでしょう。上司からの依頼内容は兎も角、唐突なプレゼン依頼って結構あるんじゃないでしょうか。似た例としては、「あなたのチームのプロダクトを他のチームのみんなにも紹介してほしい」或いは「共有すべきトレンドを紹介してほしい」
                            「業界内で注目されているXXについてナレッジシェアをしてほしい」そんな場面って多いですよね。実際のところ、ほぼ100％の人がちゃんとコンテンツを考えられますし、99％のリスナーは満足しています。満足している人たちの感想はこうです。
                            知らないことが知れてよかった。面白い内容だった。会社によっては、プレゼンの満足度調査があり、その結果を見てあなたも満足することでしょう。でも、大抵の場合、上司や他のマネジメント層は満足していません。何故なら、彼らの知りたいことじゃなかったからです。

                            改めて、ケーススタディを見返してみてください。上司は何を求めているでしょうか。30秒自分でも考えてみたあとに、下記の解答例1（ダメな例）を読んでみてください。
                            <br />
                            <br />
                            <Card elevation={3}>
                                <CardContent>
                                    <Typography variant="h4" style={{ fontSize: '22px' }}>解答例1（ダメな例） </Typography>
                                    <Typography paragraph style={{ fontSize: '20px' }}>
                                        <br />（ここでは、依頼を受けた人をJohnさんと呼びましょう）Johんさんは、ナレッジシェアということで、「昨今の市場トレンドと自分のチームの直近の半年の売上上昇の状況」をアジェンダとしてプレゼンをすることにしました。
                                        まずは、もともとチーム内で実施した市場調査や競合調査の内容も共有しながら、各セグメントのトレンドなどを紹介しました。コンテンツは盛りだくさんです。（実際に、トレンドをしっかりと分析したものでしたし、チームで得た様々な学びも含めて
                                        紹介していたため、会は盛況に終わりました）
                                    </Typography>
                                </CardContent>
                            </Card>
                            <br />
                            <br />

                            解答例1を読んでどうでしょう。よくある会社の勉強会の風景ですよね。理由はよくわからないけど、週次でミーティングがセットされていて、100人規模のメンバーが参加しているなんてこともあるでしょう。毎回のコンテンツは真新しいものですし、リスナーは
                            毎回何か学んだ気になっていることでしょう。でも、上司は不満そうです。何故でしょうか。次に、正解例を見てみましょう。（実際のところ答えは無限大なので、今からいう答えは正解のうちの一つでしかありませんが。）
                            <br />
                            <br />
                            <Card elevation={3}>
                                <CardContent>
                                    <Typography variant="h4" style={{ fontSize: '22px' }}>解答例2（良い例） </Typography>
                                    <Typography paragraph style={{ fontSize: '20px' }}>
                                        <br />　（ここでは、依頼を受けた人をTomさんと呼びましょう）Tomさんは上司の真意は何かを考え始めました。上司はディパートメントヘッドですから、組織全体の効率化・マネジメントが大事な仕事の一つです。一方で、今回Tomさんに
                                        アジェンダなく依頼してきているくらいですから、効率化に向けて何に梃入れすべきか、あまり解像度は深くないのかもしれません。Tomさんは、仮説としてまず上司の真意（イシュー）をこう捉えました。「ディパートメント内で連携あるいはナレッジシェアすべき項目自体を
                                        体系化・構造化した上で明らかにし、そのナレッジを持っているチームを明らかにする。そして継続的に連携を行いたい（が、現状はできていない）。」その仮説に基づくと、プレゼンの前半ではTomさんなりにナレッジシェアすべき項目自体を列挙・構造化した上で、あくまでも
                                        一例として一つの項目を選びTomさんのチームの良い部分の一つを紹介しました。プレゼンの後半では他のチームとインタラクティブに、何をナレッジシェアすべきかをディスカッションする時間としました。
                                    </Typography>
                                </CardContent>
                            </Card>
                            <br />
                            <br />
                            実際のところ答えは無限大なので、あくまで解答例2は正解のうちの一つでしかありません。でも、大事なのはステークホルダーのイシューを分析したことです。ナレッジシェアというと、もはやナレッジシェアが目的として押し進める人が大半ですが、
                            プレゼンスキルの高い人はすべてのステークホルダーの課題感をしっかりと分析し、その課題感に対して答えを出します。ここでいうステークホルダーは上司やマネジメント陣、そして最後にプレゼンのリスナーです。上司やマネジメント陣が実現したいことに答えを出しつつ、プレゼンのリスナーの満足度も上げる。
                            それが満たされたときが正解と言えるでしょう。

                            <br />
                            <br />

                            どうでしょうか。プレゼンにおけるイシュー分析の重要性がわかったかと思います。プレゼンをする際には、イシュー分析から始めることを意識してください。
                        </Typography>
                    </CardContent>
                    <Divider id="2" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>イシューの構造化とは何か</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            さて、イシュー分析の重要性がわかったところで、イシューの構造化の話をしたいと思います。これに関しては、百聞は一見にしかず - 実例を見ていきましょう。

                            <br />
                            <br />
                            <CardMedia
                                component="img"
                                sx={{

                                    objectFit: 'cover',
                                }}
                                image={GL_IMAGE}
                                alt="image of the category"
                            />

                            <br />
                            ご覧いただけたように、検討論点とその詳細な内容を構造化した上で見せています。（通例、プレゼンテーションの冒頭で説明します）
                            そうすることでこのプレゼンテーション全体の検討内容がはっきりとしますし、リスナーも全体構成を意識しながら聞くことができます。
                            少し話題は逸れますが、プレゼン全体の構成もこの検討論点の構造ベースで構成していくと
                            非常に綺麗にまとまりますので、みなさんも是非、真似してみてください。

                            <br /><br />
                            <CardContent>
                                <TipsAndUpdatesIcon /> 最後に、戦略コンサルティングファームであるArthur D. Littleの公開資料のリンクを下記にご紹介します。P2ページに検討論点がまとまっていますね。
                                <blockquote>
                                    <Typography variant="body2" color="text.secondary">
                                        出典:METI <a href="https://www.meti.go.jp/meti_lib/report/2020FY/000368.pdf" target="_blank" rel="noopener noreferrer"> meti.go.jp </a> (p2) - Arthur D. Little
                                    </Typography>
                                </blockquote>
                            </CardContent>

                        </Typography>
                    </CardContent>

                    <Divider id="3" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>最後に一言</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            上記のケーススタディを通じて学んだように、日々の業務やちょっとした依頼で発生するプレゼンを中心に、ただただコンテンツプロバイダーと化している人が非常に多いです。
                            勿論、有用なコンテンツを共有するということはプレゼンの目的の一つではあるので、必ずしもそれが悪いことではないです。ただし、プレゼンの背景にある課題感、イシューを意識してみると
                            また違った新しい切り口でのプレゼンが可能となることがお分かりいただけたのではないでしょうか。プレゼンを始める際には下記の2つをやってみてください。
                            「イシューを洗い出そう。そして、構造化しよう。」
                        </Typography>
                    </CardContent>

                    <Divider style={{ margin: '20px 0' }} />
                    <CardContent>
                        <A8AXIS />
                    </CardContent>
                    <Button
                        variant="text"
                        size="small"
                        endIcon={<ShareIcon />}
                        style={{ color: 'black' }}
                        onClick={() => handleImageClick("/")}
                    >
                        他のプレゼンテーションスキルを学ぶ（記事一覧へ）
                    </Button>
                </Card>
            </Box>
        </div>
    );
};

export default Article;
